import React, { useEffect, useState } from "react";
import Select from "react-select";
import { TextField } from "@mui/material";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import { Form } from "react-bootstrap";
import dayjs from "dayjs";
import axios from "axios";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router";

const CreateNewCoupon = () => {
  const { user } = useSelector((state) => state.auth);

  const { id } = useParams();

  const token = user?.token;

  const newBaseUrl = "https://estbn.com/EstbnNew/public";

  const headers = {
    Authorization: "Bearer " + token,
  };

  const getCouponDetails = async () => {
    try {
      let response = await axios.get(`${newBaseUrl}/api/portal/coupons/${id}`, {
        headers,
      });
      console.log(response.data.data.coupon);
      let coupon = response.data.data.coupon;
      setForm({
        code: coupon?.code || "",
        discount_type: coupon?.discount_type || "",
        discount_value: coupon?.discount_value || "",
        points_required: coupon?.points_required || "",
        max_usage_per_user: coupon?.max_usage_per_user || "",
        max_total_usage: coupon?.max_total_usage || "",
        min_order_price: coupon?.min_order_price || "",
        max_order_price: coupon?.max_order_price || "",
        valid_from: coupon?.valid_from || "",
        valid_until: coupon?.valid_until || "",
      });

      if (coupon?.valid_from && coupon?.valid_until) {
        setDateRange([
          new Date(coupon.valid_from),
          new Date(coupon.valid_until),
        ]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const navigate = useNavigate();

  const [form, setForm] = useState({
    code: "",
    discount_type: "",
    discount_value: "",
    points_required: "",
    max_usage_per_user: "",
    max_total_usage: "",
    min_order_price: "",
    max_order_price: "",
    valid_from: "",
    valid_until: "",
  });

  const [dateRange, setDateRange] = useState([null, null]);

  const discountTypeOption = [
    { value: "fixed", label: "Fixed Value" },
    { value: "percentage", label: "Percentage" },
  ];

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (dateRange[0] && dateRange[1]) {
      form.valid_from = dayjs(dateRange[0]).format("YYYY-MM-DD");
      form.valid_until = dayjs(dateRange[1]).format("YYYY-MM-DD");
    }

    const formData = new FormData();
    Object.entries(form).forEach(([key, value]) => {
      if (value) formData.append(key, value);
    });
    if (id) {
      formData.append("_method", "PATCH");
    }
    try {
      const res = await axios.post(
        id
          ? `https://estbn.com/EstbnNew/public/api/portal/coupons/${id}`
          : `https://estbn.com/EstbnNew/public/api/portal/coupons`,
        formData,
        {
          headers,
        }
      );
      console.log("Coupon Created:", res.data);
      toast.success(
        id ? "Coupon Updated successfully" : "Coupon created successfully",
        { autoClose: 3000 }
      );
      navigate("/Coupons");
    } catch (err) {
      console.error("Error creating coupon:", err);
      toast.error("Failed to create coupon!", { autoClose: 3000 });
    }
  };

  useEffect(() => {
    getCouponDetails();
  }, [id]);

  return (
    <div className="m-4 min-vh-100">
      <h5 className="fw-bold py-2">
        {" "}
        {id ? "Update Coupon" : "Create New Coupon"}
      </h5>
      <div>
        <form className="border rounded-3 p-4" onSubmit={handleSubmit}>
          <h5>General Info</h5>
          {/* code */}
          <TextField
            label="Coupon Code"
            placeholder="Enter Code"
            fullWidth
            size="small"
            margin="normal"
            value={form.code}
            onChange={(e) => handleChange("code", e.target.value)}
            required
          />
          {/* discount type & value */}
          <div className="row justify-content-between align-items-center">
            {/* type */}
            <div className="col-md-6 mt-1">
              <Select
                options={discountTypeOption}
                value={
                  discountTypeOption.find(
                    (opt) => opt.value === form.discount_type
                  ) || null
                }
                placeholder="Select Discount Type *"
                required
                onChange={(option) =>
                  handleChange("discount_type", option.value)
                }
                styles={{
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 1500,
                  }),
                  menu: (base) => ({
                    ...base,
                    zIndex: 1500,
                  }),
                }}
              />
            </div>
            {/* value */}
            <div className="col-md-6">
              <TextField
                type="number"
                label="Discount Value"
                placeholder="Enter Value"
                fullWidth
                size="small"
                margin="normal"
                value={form.discount_value}
                onChange={(e) => handleChange("discount_value", e.target.value)}
                required
              />
            </div>
          </div>
          {/* points & dates */}
          <div className="row justify-content-between align-items-center">
            {/* points */}
            <div className="col-md-6 mb-1">
              <TextField
                type="number"
                label="Points Required"
                fullWidth
                size="small"
                margin="normal"
                value={form.points_required}
                onChange={(e) =>
                  handleChange("points_required", e.target.value)
                }
              />
            </div>
            {/* dates  */}
            <div className="col-md-6">
              <Form.Group>
                <Flatpickr
                  className="form-control py-2"
                  placeholder="Select Dates"
                  options={{
                    mode: "range",
                    dateFormat: "Y-m-d",
                    showMonths: 2,
                  }}
                  value={dateRange}
                  onChange={(selectedDates) => {
                    setDateRange(selectedDates);
                  }}
                />
              </Form.Group>
            </div>
          </div>
          {/* order price range */}
          <div className="row">
            <h5 className="my-2">Usage restriction</h5>
            {/* minimum*/}
            <div className="col-md-6">
              <TextField
                type="number"
                label="Minimum Order Price"
                fullWidth
                size="small"
                margin="normal"
                value={form.min_order_price}
                onChange={(e) =>
                  handleChange("min_order_price", e.target.value)
                }
              />
            </div>
            {/* maximum */}
            <div className="col-md-6">
              <TextField
                type="number"
                label="Maximum Order Price"
                fullWidth
                size="small"
                margin="normal"
                value={form.max_order_price}
                onChange={(e) =>
                  handleChange("max_order_price", e.target.value)
                }
              />
            </div>
          </div>
          {/* limits */}
          <div className="row">
            <h5 className="mt-3 mb-2">Usage Limits</h5>
            {/* per user */}
            <div className="col-md-6">
              <TextField
                type="number"
                label="Max Usage Per User"
                fullWidth
                size="small"
                margin="normal"
                value={form.max_usage_per_user}
                onChange={(e) =>
                  handleChange("max_usage_per_user", e.target.value)
                }
                required
              />
            </div>
            {/* total */}
            <div className="col-md-6">
              <TextField
                type="number"
                label="Max Total Usage"
                fullWidth
                size="small"
                margin="normal"
                value={form.max_total_usage}
                onChange={(e) =>
                  handleChange("max_total_usage", e.target.value)
                }
              />
            </div>
          </div>
          {/* footer */}
          <div className="d-flex justify-content-center mt-4 w-25 mx-auto">
            <button type="submit" className="btn btn-dark px-5 py-2 w-50">
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateNewCoupon;
